import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Authentication from './pages/authentication';
import PromptInput from './pages/prompt-input';
import DownloadModal from './pages/download-modal';
import LandingPage from './pages/landing-page';
import ProjectDashboard from './pages/project-dashboard';
import CodeGeneration from './pages/code-generation';
import App from './pages/file-explorer';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/authentication" element={<Authentication />} />
        <Route path="/prompt-input" element={<PromptInput />} />
        <Route path="/download-modal" element={<DownloadModal />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/project-dashboard" element={<ProjectDashboard />} />
        <Route path="/code-generation" element={<CodeGeneration />} />
        <Route path="/file-explorer" element={<App />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
